
import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const gexPairGetter = function (PineJS) {
 return Promise.resolve([
   {
     name: 'SPX GEX Pair',
     metainfo: {
       metainfoVersion: 53,
       id: "SPX_GEX_Pair@tv-basicstudies-1",
       description: "SPX GEX Pair",
       shortDescription: "SPX GEX Pair",
       linkedToSeries: true,
       is_price_study: false,
       format: { type: "price" },
       plots: [
         {
           id: "calls_gex",
           type: "line",
           title: "Calls GEX"
         },
         {
           id: "puts_gex",
           type: "line",
           title: "Puts GEX"
         },
         {
           id: "zero_line",
           type: "line",
           title: "Zero Line"
         }
       ],
       defaults: {
         styles: {
           calls_gex: {
             linestyle: 0,
             linewidth: 1,
             plottype: 0,  // Line plot
             trackPrice: false,
             transparency: 0,
             visible: true,
             color: "#00ff1a"  // Green for calls
           },
           puts_gex: {
             linestyle: 0,
             linewidth: 1,
             plottype: 0,  // Line plot
             trackPrice: false,
             transparency: 0,
             visible: true,
             color: "#ff0000"  // Red for puts
           },
           zero_line: {
             linestyle: 0,
             linewidth: 1,
             color: "#ffffff",  // White zero line
             visible: true
           }
         },
         precision: 2,
         inputs: {}
       },
       styles: {
         calls_gex: { title: "Calls GEX" },
         puts_gex: { title: "Puts GEX" },
         zero_line: { title: "Zero Line" }
       },
       inputs: []
     },
     constructor: function () {
       this._debugMode = true;

       this.init = function (ctx) {
         this._context = ctx;
       };

       this.main = function (ctx) {
         try {
           // Get latest data from store on each main() call
           const { greekExposures } = useGreeksWebsocketDataStore.getState();
           const spxExposures = greekExposures.spx;

           if (!spxExposures?.length) {
             if (this._debugMode) {
               // console.log('[gexPairGetter] No greek exposures data');
             }
             return [null, null, null];
           }

           const time = ctx.symbol.time;
           if (!time || isNaN(time)) {
             if (this._debugMode) {
               // console.log('[gexPairGetter] Invalid symbol time:', time);
             }
             return [null, null, null];
           }

           const timeInSec = Math.floor(time / 1000);

           // Filter and sort gamma exposures
           const gammaExposures = spxExposures
             .filter(exp => exp.greek_type === 'gamma')
             .sort((a, b) => a.timestamp - b.timestamp);

           if (!gammaExposures.length) {
             return [null, null, null];
           }

           // Find the closest data point to the requested time
           let closestExp = gammaExposures[0];
           let minDiff = Math.abs(closestExp.timestamp - timeInSec);

           for (const exp of gammaExposures) {
             const diff = Math.abs(exp.timestamp - timeInSec);

             if (diff < minDiff) {
               minDiff = diff;
               closestExp = exp;
             }
           }

           const callsValue = parseFloat(closestExp.calls_total) || 0;
           const putsValue = parseFloat(closestExp.puts_total) || 0;

           // if (this._debugMode) {
           //   console.log(`[gexPairGetter] Chart time: ${new Date(timeInSec * 1000).toLocaleString('en-US', {
           //     timeZone: 'America/New_York'
           //   })}, Using values - Calls: ${callsValue}, Puts: ${putsValue} from time: ${new Date(closestExp.timestamp * 1000).toLocaleString('en-US', {
           //     timeZone: 'America/New_York'
           //   })}`);
           // }

           return [callsValue, putsValue, 0];  // Return calls, puts, and zero line values
         } catch (err) {
           console.error('[gexPairGetter] Error in main:', err);
           return [null, null, null];
         }
       };

       this.destroy = function() {
         // No cleanup needed since we're not using subscriptions
       };
     }
   }
 ]);
};
